export const DEFAULT_RETRY_ATTEMPTS = 3
export const DEFAULT_RETRY_DELAY = 1000 // milliseconds
export const SSE_URL = `${process.env.REACT_APP_PLL_API_BASE_URL}/v4/events/sse`

export const getDefaultSSEHeaders = () => ({
  Authorization: `Bearer ${process.env.REACT_APP_API_ACCESS_KEY}`,
  'Content-Type': 'text/event-stream',
  Accept: 'text/event-stream',
  'Cache-Control': 'no-cache',
  Connection: 'keep-alive',
  'X-Requested-With': 'XMLHttpRequest',
  Pragma: 'no-cache',
  'Accept-Encoding': 'gzip, deflate, br',
  mode: 'cors',
})
